import {useState} from 'react';
import type {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import {A11y, Autoplay, EffectFade, Navigation, Pagination} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from '@mui/material';

import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import 'swiper/css/a11y';
import Banner from '../uikit/Banner';
import AdImageGallery from './AdImageGallery';
import banner1 from './assets/ads/banners/b-1.webp';
import banner2 from './assets/ads/banners/b-2.webp';
import banner3 from './assets/ads/banners/b-3.webp';
import banner4 from './assets/ads/banners/b-4.webp';
import b1_0 from './assets/ads/b1/b1-0.webp';
import b1_1 from './assets/ads/b1/b1-1.webp';
import b1_2 from './assets/ads/b1/b1-2.webp';
import b1_3 from './assets/ads/b1/b1-3.webp';
import b1_4 from './assets/ads/b1/b1-4.webp';
import b1_5 from './assets/ads/b1/b1-5.webp';
import b2_0 from './assets/ads/b2/b2-0.jpg';
import b2_1 from './assets/ads/b2/b2-1.jpg';
import b2_2 from './assets/ads/b2/b2-2.jpg';
import b2_3 from './assets/ads/b2/b2-3.jpg';
import b2_4 from './assets/ads/b2/b2-4.jpg';
import b2_5 from './assets/ads/b2/b2-5.jpg';
import b2_6 from './assets/ads/b2/b2-6.jpg';

interface AdSlide {
	image: string;
	title: string;
	description: ReactNode;
}

const b1Images = [b1_0, b1_1, b1_2, b1_3, b1_4, b1_5];
const b2Images = [b2_0, b2_1, b2_2, b2_3, b2_4, b2_5, b2_6];

const AQR_IR_BALE_URL = 'https://web.bale.ai/chat?uid=5279175428';

function AdDescription({text}: {text: string}) {
	return (
		<Box component="span" sx={{whiteSpace: 'pre-line'}}>
			{text}
			<Box
				component="a"
				href={AQR_IR_BALE_URL}
				target="_blank"
				rel="noopener noreferrer"
				sx={{color: 'primary.main'}}
			>
				@aqr_ir
			</Box>
		</Box>
	);
}

const adSlides: AdSlide[] = [
	{
		image: banner1,
		title: '🇮🇷 اطلاعیه شماره یک آستان قدس رضوی',
		description: (
			<AdDescription
				text={`ویژهٔ مراسم بدرقه، تشییع و تدفین رهبر شهید انقلاب اسلامی

📝 بسم الله الرحمن الرحیم

🔹 با عرض تسلیت ایام سوگواری سرور و سالار شهیدان، حضرت اباعبدالله الحسین (علیه‌السلام)، همان‌گونه که پیش از این نیز به استحضار ملت شریف ایران رسیده است، بارگاه منوّر رضوی آرامگاه ابدی رهبر و قائد شهید و عظیم‌الشأن امت اسلامی و سایر شهدای معظم از خانوادهٔ ایشان خواهد بود. چه فرجامی نیک تر از این که پیکر مطهر آن عزیز روشن‌ضمیر، در جوار حریم حضرت علی‌بن‌موسی‌الرضا (علیه‌السلام) آرام گیرد؛ همان ساحت قدسی که از آنجا برخاست، سال‌ها در پرتو آن زیست، از چشمه‌سار معرفتش سیراب گشت، خادمی اش را «از بزرگترین ارزش ها و افتخارات» دانست و با توسل به وجود مبارکش عمری را به مجاهدت در راه دین گذراند.

🔹 بدینوسیله آستان قدس رضوی، از تمامی خادمان، خادمیاران، زائران، مجاوران و عموم امت شریف و قدرشناس ایران اسلامی دعوت می‌کند تا با حضوری حماسی در مراسم بدرقه و تشییع رهبر شهید انقلاب اسلامی، ارادت خویش را به محضر آن مجاهد نستوه و شهید راه حق، که دینی بزرگ بر همه آزادگان جهان، به‌ویژه مردم مؤمن و مقاوم ایران اسلامی دارد، به نمایش گذارند.

🔹 خدمتگزاران آستان قدس رضوی نیز خود را مفتخر می‌دانند که در برگزاری آیین‌های بدرقه و تشییع آن خلف صالح امام خمینی (ره)، جلو‌ه ای دیگر از خدمت را به منصهٔ ظهور رسانند و ضمن حضور پرشور در این ویژه‌برنامه‌ها، زمینهٔ ارائهٔ خدمات گوناگون به شرکت‌کنندگان گرامی، به‌ویژه زائران و مجاوران حریم قدسی حضرت رضا (علیه‌السلام) را فراهم آورند. هرچند یقین داریم عموم مجاوران و ارادتمندان علی ابن موسی الرضا (علیه السلام) نیز در این میدان با تمام توان خدمتگزار خواهند بود.

🔹 همچنین، با عنایت به حساسیت‌های مرتبط با حرم مطهر رضوی، از عموم مردم عزیز درخواست می‌شود که جزئیات برنامه‌ها، خدمات و اطلاعات مربوط به این بارگاه ملکوتی را صرفاً از طریق اطلاعیه‌های رسمی آستان قدس رضوی پیگیری نمایند.

🔹 در خصوص موضوع محل تدفین پیکر قائد شهیدمان، آستان قدس رضوی تمامی تمهیدات لازم را اندیشیده که پس از تصمیم گیری نهایی توسط بیت شریف ایشان، جزئیات آن به استحضار ملت عزیزمان خواهد رسید.

🔹 در خصوص سایر موضوعات مرتبط، همچون سازوکار خدمت‌رسانی اماکن متبرکه و ویژه‌برنامه‌های فرهنگی و تبلیغی حرم مطهر در روزهای قبل و بعد از تدفین نیز تدابیر و برنامه های گسترده ای پیش بینی شده که در اطلاعیه های بعدی آستان قدس رضوی به جزئیات تشریح خواهد شد.

🖊 آستان قدس رضوی

`}
			/>
		)
	},
	{
		image: banner3,
		title: '🇮🇷 اطلاعیه شماره یک باید برخواست',
		description: <AdImageGallery images={b1Images} />
	},
	{
		image: banner2,
		title: '🇮🇷 اطلاعیه شماره دو آستان قدس رضوی',
		description: (
			<AdDescription
				text={`ویژهٔ مراسم بدرقه، تشییع و تدفین رهبر شهید انقلاب اسلامی

📝 بسم الله الرحمن الرحیم

▪️ ضمن عرض تسلیت ایام سوگواری سید و سالار شهیدان حضرت اباعبدالله الحسین‌(علیه‌السلام)، به استحضار ملت بزرگوار ایران اسلامی، به‌ویژه زائران و مجاوران بارگاه نورانی حضرت علی‌بن‌موسی‌الرضا‌(علیه آلاف التحیة و الثناء) می‌رسانیم:

🔹 آستان قدس رضوی با اولویت قطعی تداوم جریان زیارت و خدمت‌رسانی شایسته و ایمن به زائران عزیز، تمهیدات لازم را برای برگزاری شایسته مراسم تشییع و تدفین رهبر شهید انقلاب اسلامی و دیگر شهدای گران‌قدر از خانواده معظم ایشان پیش‌بینی کرده است.

🔹 در همین چارچوب و به‌منظور فراهم‌سازی مقدمات این مراسم باشکوه و معنوی، تمهیدات و تغییراتی در فرایند تشرف به زیارت بارگاه منور رضوی مدنظر قرار گرفته است.

🔹 بر این اساس، جریان زیارت و تردد زائران در صحن‌های پیرامونی حرم مطهر به‌صورت مستمر و بدون وقفه تداوم می‌یابد و محدودیت‌های تشرف و تردد، صرفاً در صحن‌ها و رواق‌های مرکزی حرم مطهر رضوی، از ظهر چهارشنبه ۱۷ تیرماه ۱۴۰۵ به‌صورت تدریجی اعمال می‌شود و تا پایان مراسم تدفین ادامه خواهد داشت.

🔹 از زائران حضرت شمس‌الشّموس (علیه‌السلام) خواهشمندیم این مهم را در برنامه‌ریزی سفر به مشهد مقدس مد نظر قرار دهند و با خادمان خود در اجرای هرچه شایسته‌تر این مراسم همکاری نمایند. یقین داریم همراهی و صبر شما، همچون همیشه، پشتوانه برگزاری آیینی در شأن حرم مطهر رضوی و رهبر شهید انقلاب اسلامی خواهد بود.

🖊 آستان قدس رضوی

`}
			/>
		)
	},
	{
		image: banner4,
		title: '🇮🇷 اطلاعیه شماره دو باید برخواست',
		description: <AdImageGallery images={b2Images} />
	}
];

export default function Ads() {
	const {t} = useTranslation();
	const [selectedSlide, setSelectedSlide] = useState<AdSlide | null>(null);

	const handleClose = () => {
		setSelectedSlide(null);
	};

	return (
		<>
			<Swiper
				className="my-0 mx-4 swiper-ads"
				modules={[EffectFade, Autoplay, Pagination, Navigation, A11y]}
				spaceBetween={10}
				effect={'fade'}
				autoplay={{
					delay: 5000,
					disableOnInteraction: false
				}}
				slidesPerView={1}
				navigation={false}
				pagination={{
					clickable: true
				}}
				scrollbar={{draggable: true}}
			>
				{adSlides.map((slide) => (
					<SwiperSlide key={slide.image}>
						<Box
							className="cursor-pointer"
							onClick={() => setSelectedSlide(slide)}
						>
							<Banner
								title=""
								className="w-full"
								image={slide.image}
							/>
						</Box>
					</SwiperSlide>
				))}
			</Swiper>

			<Dialog
				open={selectedSlide !== null}
				onClose={handleClose}
				fullWidth
				maxWidth="md"
				aria-labelledby="ad-slide-dialog-title"
				aria-describedby="ad-slide-dialog-description"
			>
				<DialogTitle id="ad-slide-dialog-title">
					{selectedSlide?.title}
				</DialogTitle>
				<DialogContent dividers>
					<DialogContentText
						id="ad-slide-dialog-description"
						className="text-base text-justify"
						component="div"
					>
						{selectedSlide?.description}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} variant="outlined">
						{t('competitions.close')}
					</Button>
				</DialogActions>
			</Dialog>

			{/*			<Swiper
			 className="my-0 mx-4 swiper-ads"
			 modules={[EffectFade, Autoplay, Pagination, Navigation, A11y]}
			 spaceBetween={10}
			 effect={'fade'}
			 autoplay={{
			 delay: 5000,
			 disableOnInteraction: false
			 }}
			 slidesPerView={1}
			 navigation={false}
			 pagination={{
			 clickable: true
			 // 	type: 'progressbar'
			 }}
			 scrollbar={{draggable: true}}
			 onSwiper={(swiper) => {
			 }}
			 onSlideChange={
			 // () => console.log('slide change')
			 () => {
			 }
			 }
			 >
			 <SwiperSlide key="1">
			 <a href="/competition/2"
			 className="flex flex-col space-y-1 items-center text-center">
			 <Banner
			 title=""
			 className="w-full"
			 // image="https://files.novinrazavi.ir/competition/3546dd12-3bf5-4036-af7f-6e793ba52187.jpg"
			 image="https://files.novinrazavi.ir/competition/80432f9f-7b03-4378-ba09-aad54fbdd5ca.gif"
			 />
			 </a>
			 </SwiperSlide>
			 <SwiperSlide key="1">
			 <Banner
			 title=""
			 className="w-full"
			 image="https://files.novinrazavi.ir/competition/6f782997-7018-494f-89e0-5a021ca7c6ad.jpg"
			 />
			 </SwiperSlide>
			 <SwiperSlide key="1">
			 <a href="/competition/tekyehmajazi"
			 className="flex flex-col space-y-1 items-center text-center">
			 <Banner
			 title=""
			 className="w-full"
			 image="https://files.novinrazavi.ir/competition/tekye-baner.webp"
			 />
			 </a>
			 </SwiperSlide>
			 <SwiperSlide key="2">
			 <a href="https://www.razavi.ir/fa/barandebash"
			 <a href="https://www.razavi.ir/barandebash"
			 <a href="https://haram.razavi.ir/quiz/116"
			 className="flex flex-col space-y-1 items-center text-center">
			 <Banner
			 title=""
			 className="w-full"
			 image="https://files.novinrazavi.ir/competition/najva.webp"
			 />
			 </a>
			 </SwiperSlide>
			 <SwiperSlide key="2">
			 <Banner
			 title=""
			 className="w-full"
			 image="https://files.novinrazavi.ir/competition/de726bbe-b79d-4722-b45a-f6153dbac5bd.jpg"
			 />
			 </SwiperSlide>
			 <SwiperSlide key="3">
			 <Banner
			 title=""
			 className="w-full"
			 image="https://files.novinrazavi.ir/competition/37e9e4da-261a-4f15-999c-e04df54fb353.jpg"
			 />
			 </SwiperSlide>
			 <SwiperSlide key="4">
			 <Banner
			 title=""
			 className="w-full"
			 image="https://files.novinrazavi.ir/competition/7e62ad04-396a-4c7b-b395-45d47d616f59.jpg"
			 />
			 </SwiperSlide>
			 <SwiperSlide key="5">
			 <Banner
			 title=""
			 className="w-full"
			 image="https://files.novinrazavi.ir/competition/a97842c0-1e21-4b43-91ce-f9c6aad049a9.jpg"
			 />
			 </SwiperSlide>
			 </Swiper>*/}
			{/*<Swiper
			 className="my-0 mx-4 swiper-ads"
			 modules={[EffectFade, Autoplay, Pagination, Navigation, A11y]}
			 spaceBetween={10}
			 effect={'fade'}
			 autoplay={{
			 delay: 5000,
			 disableOnInteraction: false
			 }}
			 slidesPerView={1}
			 navigation={false}
			 pagination={{
			 clickable: true
			 // 	type: 'progressbar'
			 }}
			 scrollbar={{draggable: true}}
			 onSwiper={(swiper) => {
			 }}
			 onSlideChange={
			 // () => console.log('slide change')
			 () => {
			 }
			 }
			 >
			 <SwiperSlide key="1">
			 <Link to="/competition/imamreza">
			 <Banner
			 title=""
			 className="w-full"
			 image="https://files.novinrazavi.ir/rezvan/600.150.webp"
			 />
			 </Link>
			 </SwiperSlide>
			 </Swiper>*/}
			{/*<Swiper
			 className="my-0 mx-4 swiper-ads"
			 modules={[EffectFade, Autoplay, Pagination, Navigation, A11y]}
			 spaceBetween={10}
			 effect={'fade'}
			 autoplay={{
			 delay: 5000,
			 disableOnInteraction: false
			 }}
			 slidesPerView={1}
			 navigation={false}
			 pagination={{
			 clickable: true
			 // 	type: 'progressbar'
			 }}
			 scrollbar={{draggable: true}}
			 onSwiper={(swiper) => {
			 }}
			 onSlideChange={
			 // () => console.log('slide change')
			 () => {
			 }
			 }
			 >
			 <SwiperSlide key="1">
			 <Link to="/competition/muharram">
			 <Banner
			 title=""
			 className="w-full"
			 image="https://files.novinrazavi.ir/competition/banner-barande.webp"
			 />
			 </Link>
			 </SwiperSlide>
			 </Swiper>*/}
		</>
	);
}
